import { window } from '../window.js';
import { HTMLControl } from './html_control.js';
import './popup_control.js';

/**
 * Number control.
 */
class NumberControl extends HTMLControl {
  static get markup() {
    return `
<span class='editable-control' tabindex='-1'>
  <span class='editable-control-label'></span>
  <span class='editable-control-value-container'>
    <span class='editable-control-value'></span>
    <input type='number' class='editable-control-number'
           min='1' max='99' tabindex='0'>
  </span>
</span>
<popup-control></popup-control>
`;
  }

  static properties = {
    label: {
      attribute: true,
      set(v) {
        this.labelElement.innerHTML = `${v}:&nbsp;`;
      },
    },
    errorMessage: {
      set(v) {
        this.popupElement.innerHTML = v;
      },
    },
    plainStyle: {
      attribute: {
        name: 'plain',
        type: 'boolean',
      },
      set(v) {
        this.editableControlElement.setAttribute('tabindex', v ? 0 : -1);
      },
    },
    value: {
      attribute: true,
      get() {
        return this.numberElement.value;
      },
      set(v) {
        this.valueElement.textContent = v;
        this.numberElement.value = v;
      },
    },
  };

  initialize() {
    this.classList.add('popup-arrow', 'editable-control-container');

    super.initialize();

    this.editableControlElement.onfocus = this.onFocus.bind(this);

    let inputEl = this.numberElement;
    inputEl.onfocus = this.onInputFocus.bind(this);
    inputEl.onblur = this.onInputBlur.bind(this);
    inputEl.onchange = () =>
      setTimeout(() => {
        this.valueElement.textContent = inputEl.value;
        if (this.validate() && this.onchange) {
          this.onchange();
        }
      }, 0);
  }

  get readonly() {
    return this.numberElement.readOnly;
  }

  set readonly(val) {
    this.numberElement.readOnly = val;
  }

  onFocus() {
    this.editableControlElement.setAttribute('hasfocus', 'true');
    this.numberElement.focus();
  }

  onInputFocus() {
    this.editableControlElement.setAttribute('hasfocus', 'true');
  }

  onInputBlur() {
    this.editableControlElement.removeAttribute('hasfocus');
    this.hideBalloon();
  }

  checkValidity() {
    return parseInt(this.value) > 0;
  }
  showBalloon() {
    this.popupElement.open = true;
  }
  hideBalloon() {
    this.popupElement.open = false;
  }

  validate() {
    let el = this.editableControlElement;
    if (this.checkValidity()) {
      el.removeAttribute('invalid');
      this.hideBalloon();
      return true;
    }

    el.setAttribute('invalid', 'true');
    el.focus();
    this.showBalloon();
    return false;
  }

  static selectors = {
    EditableControl: '.editable-control',
    Label: '.editable-control-label',
    Number: '.editable-control-number',
    Popup: 'popup-control',
    Value: '.editable-control-value',
  };

  static elements = {
    editableControlElement: this.selectors.EditableControl,
    labelElement: this.selectors.Label,
    numberElement: this.selectors.Number,
    popupElement: this.selectors.Popup,
    valueElement: this.selectors.Value,
  };
}

window.customElements.define('number-control', NumberControl);

export { NumberControl };
